import shiftLock from './shiftLock';
import literalKeys from './literalKeys';
import layoutSwitch from './layoutSwitch';
import multiKeyboards from './multiKeyboards';
import specialTypes from './specialTypes';
import sentenceCase from './sentenceCase';
import Language from '../../../types/LanguageEnum';
import { createDictionary } from 'utils/objectUtils';
import { chineseCandidatesModule, chineseModule } from '../Custom/Chinese/modules';
import { CandidatesKeyboard } from '../types';

// Keyboard modules must be `function`s, not arrow functions: simple-keyboard instantiates constructible modules with
// `new`, but plainly calls the others and reads `.init` on their (here undefined) return value, which crashes on open.
const COMMON_MODULES:((props: CandidatesKeyboard) => void)[] = [shiftLock, literalKeys, multiKeyboards, specialTypes];

const DEFAULT_MODULES = [...COMMON_MODULES, sentenceCase];

const CHINESE_MODULES = [...COMMON_MODULES, layoutSwitch, chineseCandidatesModule, chineseModule];

export const MODULES = createDictionary<Language, ((props: CandidatesKeyboard) => void)[]>({
  [Language.ZH_CN]: CHINESE_MODULES,
  [Language.ZH_TW]: CHINESE_MODULES,
  [Language.ZH_HK]: CHINESE_MODULES,
}, DEFAULT_MODULES);